import React, { useState, useEffect } from 'react'
import { Monitor } from '@mui/icons-material'
import './floatingButton.css'
import { ROUTES } from 'Utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { setActiveCustomerDisplay } from 'redux/actions/customerDisplayActions'

import ModalAlertGeneric from 'Components/ModalAlertGeneric/ModalAlertGeneric'

import Loading from 'Components/Loading'

export default function FloatingCustomerDisplayButton() {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [isSleepMode, setIsSleepMode] = useState(false)
  const [loaderFullScreen, setLoaderFullScreen] = useState(false)
  const [invalidActive, setInvalidActive] = useState(false)
  const channelRef = React.useRef(null)

  const { isActiveCustomerDisplay } = useSelector(
    state => state.customerDisplay
  )

  // Initialize channel once
  if (!channelRef.current) {
    channelRef.current = new BroadcastChannel('customer_display')
  }
  const channel = channelRef.current

  useEffect(() => {
    // --- Detectar cuando el usuario va a refrescar o cerrar la pestaña ---
    const handleBeforeUnload = () => {
      sessionStorage.setItem('isRefreshing', 'true') // guardamos bandera
      if (!location.pathname.includes(ROUTES.editQuoteHeaderId)) {
        handleClose() // ejecuta inmediatamente antes del refresh
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    const isRefreshing = sessionStorage.getItem('isRefreshing')
    if (isRefreshing) {
      sessionStorage.removeItem('isRefreshing')
    }

    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [])

  const handleActiveCustomerDisplay = () => {
    const showCustomer =
      location.pathname.includes(ROUTES.createQuote) ||
      location.pathname.includes(ROUTES.editQuoteHeaderId)

    setInvalidActive(!showCustomer)
    if (!showCustomer) return
    const newActiveCustomerDisplay = !isActiveCustomerDisplay
    channel.postMessage({ isSleepMode: true })
    dispatch(setActiveCustomerDisplay(newActiveCustomerDisplay))
    setOpen(false)
    if (newActiveCustomerDisplay) {
      const url = `${window.location.origin}${ROUTES.customerDisplay}`

      // 🔹 Detectar resolución del monitor principal
      const primaryWidth = window.screen.width
      const primaryHeight = window.screen.height

      // 🔹 Asumir que la pantalla extendida está a la derecha
      const left = primaryWidth // inicia justo después del monitor principal
      const top = 0

      // 🔹 Tamaño de la nueva ventana (misma resolución que la principal)
      const width = primaryWidth
      const height = primaryHeight

      // 🔹 Abrir ventana del Customer Display
      const win = window.open(
        url,
        '_blank',
        `width=${width},height=${height},left=${left},top=${top},
           toolbar=no,menubar=no,location=no,status=no,scrollbars=no,
           resizable=no,noopener,noreferrer`
      )

      setLoaderFullScreen(true)
      // 🔹 Foco y opcional: recordar posición para futuros usos
      if (win) {
        win.focus()
        localStorage.setItem('customerDisplayLeft', left)
        localStorage.setItem('customerDisplayTop', top)
        localStorage.setItem('customerDisplayWidth', width)
        localStorage.setItem('customerDisplayHeight', height)

        win.onload = () => {
          try {
            win.document.documentElement.requestFullscreen()
          } catch (err) {
            console.warn('No se pudo poner en pantalla completa:', err)
          }
        }
      }
    }
  }

  const handleClose = () => {
    setOpen(false)
    channel.postMessage({ windowClose: true })
    dispatch(setActiveCustomerDisplay(false))
  }

  const handleSleepMode = () => {
    setOpen(false)
    const newMode = !isSleepMode
    setIsSleepMode(newMode)
    channel.postMessage({ isSleepMode: newMode })
  }

  useEffect(() => {
    if (channelRef.current) {
      channelRef.current.onmessage = event => {
        if (event.data.isSleepMode !== undefined) {
          setIsSleepMode(event.data.isSleepMode)
        }
        if (event.data.isFullScreen === true) {
          setLoaderFullScreen(false)
        }
      }
    }

    return () => {
      if (channelRef.current) {
        channelRef.current.close()
        channelRef.current = null
      }
    }
  }, [])

  return (
    <>
      <div
        className="floating-container"
        data-testid="container-floating-customer-display">
        {/* Opciones desplegables */}
        <div
          className={`menu ${open ? 'open' : ''}`}
          data-testid="container-menu-customer-display">
          <button
            data-testid="btn-toggle-customer-display"
            className={
              isActiveCustomerDisplay ? 'menu-btn activate' : 'menu-btn'
            }
            onClick={
              isActiveCustomerDisplay
                ? handleClose
                : handleActiveCustomerDisplay
            }>
            {isActiveCustomerDisplay ? 'Desactivar' : 'Activar'}
          </button>
          <button
            data-testid="btn-sleep-mode-customer-display"
            className={isSleepMode ? 'menu-btn activate' : 'menu-btn'}
            onClick={handleSleepMode}
            disabled={!isActiveCustomerDisplay}>
            {isSleepMode ? 'Continuar' : 'Reposo'}
          </button>
        </div>

        {/* Botón flotante */}
        <button
          data-testid="btn-open-menu-customer-display"
          className={`fab ${open ? 'open' : ''}`}
          onClick={() => setOpen(!open)}>
          <Monitor fontSize="large" />
        </button>
      </div>
      {loaderFullScreen && <Loading full />}
      <ModalAlertGeneric
        isError={invalidActive}
        setIsError={setInvalidActive}
        messageSettings={{
          message: 'CUSTOMER_DISPLAY.MODAL_ALERT_INVALID_ACTIVE',
          status: 'error',
        }}
        setMessageSettings={() => {}}
        data-testid="modal-invalid-active"
      />
    </>
  )
}
